import styled from "styled-components";

export const MyCardsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: inherit;

  width: 100%;
`;

export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  margin: 1rem 0;

  border-radius: 10px;
  width: 100%;

  background-color: #ffffff;

  button {
    display: flex;
    align-items: center;
    gap: 2rem;

    width: 100%;
    padding: 1rem;

    background-color: transparent;
    color: #7f7f7f;
    border: none;
    border-bottom: 1px solid #d8d8d8;

    cursor: pointer;

    > img {
      width: 4.5rem;
    }

    > div {
      width: 100%;
      text-align: start;

      * {
        margin: 0;
      }

      p {
        color: #000;
        margin-top: 0.5rem;
      }
    }
  }
`;

export const AddCardButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  width: fit-content;
  padding: 0.5rem;
  margin: 0 auto;

  background-color: transparent;
  border: none;
  color: #2497ff;

  cursor: pointer;
`;
